/* =========================================================
   Featured Category Showcase — Vanilla JS
   Scroll-reveal fade in with stagger, no dependencies.
   ========================================================= */

(function () {
  'use strict';

  var STAGGER_STEP_MS = 90;

  function initSection(section) {
    var animatedEls = section.querySelectorAll('[data-csc-animate]');
    if (!animatedEls.length) return;

    if (!('IntersectionObserver' in window)) {
      animatedEls.forEach(function (el) {
        el.classList.add('csc-in-view');
      });
      return;
    }

    var itemIndex = 0;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var el = entry.target;

          if (el.classList.contains('category-showcase__item')) {
            el.style.setProperty('--csc-delay', itemIndex * STAGGER_STEP_MS + 'ms');
            itemIndex += 1;
          }

          el.classList.add('csc-in-view');
          observer.unobserve(el);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.15,
      }
    );

    animatedEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    var sections = document.querySelectorAll('.category-showcase');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init when a section is added/edited in the Theme Editor */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.category-showcase');
    if (section) initSection(section);
  });
})();
